import { DateTime } from 'luxon';

import {
  GeneralSetting,
  useGeneralSetting,
} from '../../util/use-general-setting';
import {
  DateWheelPickerField,
  IWheelPickerProps,
} from '../date-wheel-picker-field/DateWheelPickerField';

export const StatisticDateWheelPickerField = (
  props: Omit<IWheelPickerProps, 'labeledInputValue'>
) => {
  const startBusinessYearSetting = useGeneralSetting({
    name: GeneralSetting.startBusinessYear,
  });

  const businessYearStart = DateTime.fromJSDate(props.value).year;
  const businessYearEnd = businessYearStart + 1;

  return (
    <DateWheelPickerField
      {...props}
      labeledInputValue={
        startBusinessYearSetting.data[0]?.value > 1
          ? `${businessYearStart} - ${businessYearEnd}`
          : undefined
      }
    />
  );
};
